<script lang="ts">
  import { cn } from "@/helpers/tw-utils";
  import { type ImageMetadata } from "astro";

  type ImgProps = {
    src: string;
    w: number;
  };
  type ImgPropsH = ImgProps & { h: number };

  type ImgMeta = {
    img: ImgPropsH;
    sources: { [key: string]: string };
  };

  interface Props {
    src: string | ImageMetadata;
    sizes?: string;
    alt?: string;
    loading?: "lazy" | "eager" | null | undefined;
    pictureClass?: string;
    class?: string;
    [key: string]: any;
  }

  let {
    src,
    sizes = "",
    alt = "",
    loading = "lazy",
    pictureClass = "",
    class: className = "",
    ...rest
  }: Props = $props();

  // let srcTyped: ImgMeta = $state(src as unknown as ImgMeta);
  // // if there is only one, vite-imagetools won't wrap the object in an array
  // if (srcTyped instanceof Array && srcTyped && srcTyped[0])
  //   srcTyped = srcTyped[0];

  let srcTyped = $derived.by(() => {
    let val = src as unknown as ImgMeta;
    if (val instanceof Array && val && val[0]) val = val[0];
    return val;
  });
</script>

{#if typeof src === "object" && "src" in src}
  <img
    src={src.src}
    width={src.width}
    height={src.height}
    {alt}
    {loading}
    class={cn("h-full w-full", className)}
    {...rest} />
{:else if typeof src === "string"}
  <img {src} {alt} {loading} class={cn("h-full w-full", className)} {...rest} />
{:else}
  <picture class={pictureClass}>
    {#each Object.entries(srcTyped.sources) as [type, srcMeta]}
      <source type="image/{type}" {sizes} srcset={srcMeta} />
    {/each}
    <img
      src={srcTyped.img.src}
      width={srcTyped.img.w}
      height={srcTyped.img.h}
      {alt}
      {loading}
      class={cn("h-full w-full", className)}
      {...rest} />
  </picture>
{/if}
